import { Action } from '@ngrx/store';
import { StoresActions, StoresActionTypes } from './stores.actions';


export const storesFeatureKey = 'stores';

export interface State {

}

export const initialState: State = {
  stores: <any>{},
  error: <any>''
};

export function reducer(state = initialState, action: StoresActions): State {
  switch (action.type) {

    case StoresActionTypes.LoadStoress:
      return {
        ...state
      }

    case StoresActionTypes.LoadStoressSuccess:
      return {
        ...state,
        stores: action.payload.data,
        error: '',
      }

    case StoresActionTypes.LoadStoressFailure:
      return {
        ...state,
        stores: <any>{},
        error: action.payload.error,
      }

    default:
      return state;
  }
}
